import React, { useState } from "react";
import Verification from "../Verification";
import ProfileManagment from "./ProfileManagment";
import LoginForm from "../LoginForm";
import RegisterForm from "../RegisterForm";
import ForgotPasswordForm from "../ForgotPassword";
import VerifyForm from "../Verify";
import VerifyAdmin from "./VerifyAdmin";
import OtpVerifyForm from "../OtpVerifyForm";
import RegisterConfirm from "../RegisterConfirm";
// import RegisterConfirm from "../../../../Pages/RegisterConfirm";
import OtpRegisterForm from "../OtpRegisterForm";


//import ssoImg1 from "./../../../../assets/images/verification2025.jpg"; // Adjust the path as necessary

// QA


function VerificationsAdmin() {
  const [activeForm, setActiveForm] = useState("login");
  return (
    <>

      {/* <div className="service-title font-700 mb-3">Verifications </div> */}
      <div className="bg-white p-3 p-sm-4 p-md-5 mb-3 shadow d-flex justify-content-between align-items-start no-scroll min-height-790">

        {activeForm === "register" && <RegisterForm setActiveForm={setActiveForm} />}
        {activeForm === "login" && <LoginForm setActiveForm={setActiveForm} />}
        {/* {activeForm === "verify" && <VerifyForm setActiveForm={setActiveForm} />} */}
        {activeForm === "verify" && <VerifyAdmin setActiveForm={setActiveForm} />}
        {/* {activeForm === "ProfileManagment" && <ProfileManagment setActiveForm={setActiveForm} />} */}
        {activeForm === "forgot" && <ForgotPasswordForm setActiveForm={setActiveForm} />}
        {activeForm === "verifyOtp" && <OtpVerifyForm setActiveForm={setActiveForm} />}
        {activeForm === "registerConfirm" && <RegisterConfirm setActiveForm={setActiveForm} />}
        {activeForm === "verifyRegOtp" && <OtpRegisterForm setActiveForm={setActiveForm} />}

        {/* <ProfileManagment /> */}
      </div>
      {/* <ProfileManagment /> */}
      {/* <Verification/> */}
    </>
  );
}



export default VerificationsAdmin;




